import { SyntheticEvent, useMemo } from 'react';
import DefaultSnackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';

import _noop from '@julofinance/web-helpers/dist/fn/noop';

import { SnackbarProps } from './types';
import { SNACKBAR_AUTO_HIDE_DURATION } from './constants';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertStatus,
  AlertTitle,
} from '@julo-ui/react';

const Snackbar = (props: SnackbarProps) => {
  const {
    open,
    onClose = _noop,
    severity,
    autoHideDuration = SNACKBAR_AUTO_HIDE_DURATION,
    anchorOrigin = { horizontal: 'center', vertical: 'bottom' },
    title,
    message,
    ...resProps
  } = props;

  const handleClose = (
    event: Event | SyntheticEvent<unknown, Event>,
    reason: SnackbarCloseReason = 'timeout',
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    onClose(event, reason);
  };

  const severityMap = useMemo(() => {
    switch (severity) {
      case 'success':
        return 'positive';

      case 'error':
        return 'negative';

      case 'warning':
        return 'warning';

      default:
        return 'neutrals';
    }
  }, [severity]) as AlertStatus;

  return (
    <DefaultSnackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
      {...resProps}
    >
      <Alert status={severityMap} sx={{ borderRadius: 0, border: 0 }}>
        <AlertIcon placement='left' />
        <div>
          {!!title && <AlertTitle>{title}</AlertTitle>}
          <AlertDescription>{message}</AlertDescription>
        </div>
      </Alert>
    </DefaultSnackbar>
  );
};

export default Snackbar;
